import { c as _c } from "react/compiler-runtime";
import { useSnackbar } from "notistack";
import { useCallback, useState } from "react";
import { useCookieConsentStorage } from "#/features/cookieConsent/hooks/useCookieConsentStorage";
import { storeCookieConsent } from "#/features/cookieConsent/lib/consentStorage";
import { useI18nContext } from "#/shared/hooks";
type UseCookieConsentResult = {
  showBanner: boolean;
  isSettingsView: boolean;
  analyticsEnabled: boolean;
  acceptAll: () => boolean;
  rejectNonEssential: () => boolean;
  openCookieSettings: () => void;
  closeCookieSettings: () => void;
};
export const useCookieConsent = () => {
  const $ = _c(15);
  const {
    LL
  } = useI18nContext();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const preferences = useCookieConsentStorage();
  const [settingsOpen, setSettingsOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setSettingsOpen(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const closeCookieSettings = t0;
  let t1;
  if ($[1] !== LL || $[2] !== enqueueSnackbar) {
    t1 = analytics => {
      const stored = storeCookieConsent({
        analytics
      });
      if (stored) {
        setSettingsOpen(false);
        return true;
      }
      enqueueSnackbar(LL.COOKIE_CONSENT_STORE_FAILED(), {
        variant: "error"
      });
      return false;
    };
    $[1] = LL;
    $[2] = enqueueSnackbar;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const persistConsent = t1;
  let t2;
  if ($[4] !== persistConsent) {
    t2 = () => persistConsent(true);
    $[4] = persistConsent;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const acceptAll = t2;
  let t3;
  if ($[6] !== persistConsent) {
    t3 = () => persistConsent(false);
    $[6] = persistConsent;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const rejectNonEssential = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setSettingsOpen(true);
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const openCookieSettings = t4;
  const hasUndecidedConsent = preferences === null;
  const showBanner = hasUndecidedConsent || settingsOpen;
  const isSettingsView = settingsOpen && !hasUndecidedConsent;
  const analyticsEnabled = preferences?.analytics === true;
  let t5;
  if ($[9] !== acceptAll || $[10] !== analyticsEnabled || $[11] !== isSettingsView || $[12] !== rejectNonEssential || $[13] !== showBanner) {
    t5 = {
      showBanner,
      isSettingsView,
      analyticsEnabled,
      acceptAll,
      rejectNonEssential,
      openCookieSettings,
      closeCookieSettings
    };
    $[9] = acceptAll;
    $[10] = analyticsEnabled;
    $[11] = isSettingsView;
    $[12] = rejectNonEssential;
    $[13] = showBanner;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};